import React, { useState, useEffect, useRef } from "react";
import './product_sstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import banner from '../img/logo/banner-bg.png';
import amogh from '../img/logo/amogh.png'
import top from '../img/logo/left_top.png';
import bottom from '../img/logo/left_bottom.png';
import right_top from '../img/logo/right_top.png';
import right_bottom from '../img/logo/right_bottom.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiMail, FiPhone, FiArrowRight } from "react-icons/fi";
import 'react-medium-image-zoom/dist/styles.css';
import intro from "../img/products/speaklear_intro.gif";
import video_intro from "../img/products/video_intro.mp4";
import impo from "../img/products/impo.svg";
import usericon from "../img/products/user.svg";
import mobileicon from "../img/products/mobile.svg";
import emailicon from "../img/products/email.svg";
import Footer from "./Footer";

function Productdetailsobs() {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "" });
  const [errors, setErrors] = useState({});
  const [isYesChecked, setIsYesChecked] = useState(false);
  const [showsuccessAlert, setShowsuccessAlert] = useState(false);
  const [showfailureAlert, setShowfailureAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state
  const [isChecked, setIsChecked] = useState(false);
  const videoRef = useRef(null);
  const nextSectionRef = useRef(null);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateMobile = (mobile) => /^\d{10}$/.test(mobile);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  
    let newErrors = { ...errors };
  
    if (name === "email") {
      if (!validateEmail(value)) {
        newErrors.email = "Invalid email format";
      } else {
        delete newErrors.email; // Remove error if valid
      }
    }
  
    if (name === "mobile") {
      if (!validateMobile(value)) {
        newErrors.mobile = "Mobile number must be 10 digits";
      } else {
        delete newErrors.mobile; // Remove error if valid
      }
    }
  
    setErrors(newErrors);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate form before submission
    let newErrors = {};
    if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Stop submission if errors exist
    }
  
    setIsSubmitting(true);
    try {
      const response = await fetch("https://ableproindia.com/backend/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setShowsuccessAlert(true);
        setErrors({});
        setFormData({ name: "", email: "", mobile: "" });
  
        setTimeout(() => setShowsuccessAlert(false), 5000);
      } else {
        setShowfailureAlert(true);
        setTimeout(() => setShowfailureAlert(false), 5000);
      }
    } catch (error) {
      setShowfailureAlert(true);
      setTimeout(() => setShowfailureAlert(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };


  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleRadioChange = (e) => {
    setIsYesChecked(e.target.value === "yes");
    if (e.target.value === "no") {
      setShowfailureAlert(true);
    }
  };

  const handlehidefailuremsg = () => {
    setShowfailureAlert(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      //alert(observer);
      (entries) => {
        entries.forEach((entry) => {
          console.log(observer);
          if (entry.isIntersecting) {
            //alert('hi');
            videoRef.current?.play(); // Play video when in view
          }
        });
      },
      { threshold: 0.5 } // Play when at least 50% of video is visible
    );

    if (videoRef.current) {
    //alert(videoRef.current);
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);


  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setIsYesChecked(false);
  };

  return (
<>
<section id="Home" className="product-home-bg section_class_ss"> 
<video width="100%" autoPlay muted playsInline webkit-playsinline="true" className="video">
{/* <video ref={videoRef} width="100%" autoPlay muted playsInline webkit-playsinline="true" className="video" onEnded={scrollToNextSection}> */}
    <source src={video_intro} type="video/mp4"/>
  </video>
</section>


  <div className="snapareas" style={{ backgroundColor: "#F2F8FF", padding: "0px", margin: "0 auto" }} >


<section className="section_class_ss mt-5">
    <div className={`container_class_center container `}>
      <div className="row">
       <div className="scroll-para">
        <h3 className="pt-5" >What is it?</h3>
        <p>Speaklear™ is a self learning speech training application software that can be used by individuals as well as speech therapists for their speech therapy.</p>
        <br /><br /><br /><br /><br /><br /><br /><br />
        </div>
        
      <div>
        <img className="right_corner_ss" src="img/logo_b.png" alt="Design" width="100" />
      </div>
      
    </div>
  </div>
</section>

<section className="section_class_ss mt-5">
<div className={`container_class_center container `}>
  <div className="row">
    <div className="col-lg-12">
      <div className="scroll-para">
        <h3 className="pt-5">What is it?</h3>
        <p>Speaklear™ is a self learning speech training application software that can be used by individuals as well as speech therapists for their speech therapy.</p>
      </div>
      <div className="scroll-para">
        <h3 className="pt-5">What are we doing?</h3>
        <p>We are the first player in the digital assistive speech training space for people with speech impairments. We tackle conventional challenges of speech therapy by providing a digital tool that facilitates and makes speech learning easier.</p>
      </div>
      <div className="scroll-para">
        <h3 className="pt-5">Challenges of conventional speech therapy:</h3>
        <ul>
          <li>Availability of diligent speech therapists</li>
          <li>Limited time provision per therapist per child</li>
          <li>Expensive fees and logistical issues</li>
          <li>Demands extra attention and care</li>
          <li>NO digital tools to facilitate speech learning in India</li>
        </ul>
      </div>
      <div>
        <img className="right_corner_ss" src="img/logo_b.png" alt="Design" width="100" />
      </div>
    </div>
  </div>
</div>
</section>



<section className="section_class_ss mt-5">
  <div className="container_class_center container ">
    <div className="row">
      <p className="slide-paragraph pt-5">
        <span>Born with<br />hearing loss </span>
        <span><FiArrowRight className="blue_color_arrow" /></span>
        <span>Mother’s<br /> training</span>
        <span><FiArrowRight className="blue_color_arrow" /></span>
        <span>Personal<br /> Experience </span>
        <span><FiArrowRight className="blue_color_arrow" /></span>
        <span> New <br /> endeavour </span>
      </p>
      <div>
        <img className="right_corner_ss" src="img/logo_b.png" alt="Design" width="100" />
      </div>
    </div>
  </div>
</section>


<section className="section_class_ss mt-5">
  <div className="container_class_ss container ">
    <div className="row">
      <div className="col-lg-12">
        <p className="slide-paragraph pt-5">
          <span>Born with<br />hearing loss </span>
          <span><FiArrowRight className="blue_color_arrow" /></span>
          <span>Mother’s<br /> training</span>
          <span><FiArrowRight className="blue_color_arrow" /></span>
          <span>Personal<br /> Experience </span>
          <span><FiArrowRight className="blue_color_arrow" /></span>
          <span> New <br /> endeavour </span>
        </p>
        <h3 className="pt-5">The Why?</h3>
        <p>I was born with sensorineural congenital hearing loss. All throughout my childhood, my mother, Mrs. Shailaja, worked very hard in training me how to speak both English and Kannada which is incredible considering that I cannot learn languages by hearing. My parents are the reason I am here today, and completely independent of any speaking assistance. </p>
        <p>I empathise and understand the deep rooted issues for people with hearing and speech impairments as well as the challenges of conventional speech therapy. With personal experience and a dedicated support team, I have embarked on a new mission to enable, empower and engage with the challenged people to make speech learning easier. </p>
        <p>By merging new age Artificial Intelligence and Machine Learning technology with expert speech therapy resources, learning speech does not have to be all that difficult anymore.</p>
        <h5>-Amogh Inamdar</h5>
        <div>
        <img className="right_corner_ss" src="img/logo_b.png" alt="Design" width="100" />
      </div>
      </div>
    </div>
  </div>
</section>



<section className="section_class_ss">
  <div className="container_class_ss container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_1.png" alt="Rectangles" width="600" />
      </div>

      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 text-center">&nbsp;</h3>
    </div>
  </div>
</section>

<section className="section_class_ss"> 
  <div className="container_class_ss container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_2.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center">Un-trained speech</h3>
    </div>
  </div>
</section>

<section className="section_class_ss">
  <div className="container_class_ss container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_3.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center">Trained routine</h3>
    </div>
  </div>
</section>

<section className="section_class_ss">
  <div className="container_class_ss container ">
    <div className="row">
      <div className="chat_box mt-5">
        <img src="img/chats_4.png" alt="Rectangles" width="600" />
      </div>
      <span className="inline_rectangle_text pt-3" style={{width: '48%', margin: '0 auto'}}>
        <span>Current Speech</span>
        <span className="inline-rectangle_1"></span>
        <span>Errors</span>
        <span className="inline-rectangle_2"></span>
        <span>Interim Standard</span>
        <span className="inline-rectangle_3"></span>
        <span>Global Standard</span>
        <span className="inline-rectangle_4"></span>
      </span>
      <h3 className="pt-3 inline_center_text text-center">Achieved speech</h3>
    </div>
  </div>
</section>

<section className="section_class_ss">
  <div className="row">
    <div className="chat_box mt-5" >
      <img src="img/logo.png" alt="logo" width="400" />
    </div>
    <h3 className="pt-3 text-center">Speech learning, now easier.</h3>
  </div>
</section>


<section className="section_class_ss">
  <div className="row">
    <div className="image-container">
      <div className="rectangle ">
        <img src="img/design.png" alt="Design" />
      </div>
    </div>
  </div>
</section>

<div style={{backgroundColor: '#4072DD'}}>

<section className="section_class_ss" style={{backgroundColor:'#4072DD'}} >
  <img className="Vector_img_obs" src="img/Vector.png" alt="Design" />
  <div className="container_class_ss container ">
   <div className="row">
    <div className="col-lg-8 ">
      <h4 className="hearing_h5 pt-5" style={{ textAlign : 'left' }}>A speech mastering tool for people <br /> with speech impairments.</h4>
      <h2 className="sprre pt-3">Speak. Practise. Repeat.</h2>
      <div>
        <img className="white_logo_ss" src="img/white_logo.png" alt="Design" width="100" />
      </div>
    </div>
    <div className="col-lg-4" style={{zindex: '999', marginTop: '5%'}}>
      <img src="img/mobile_screen.png" alt="Design" width="250" />
    </div>
  </div>
</div>
</section>

</div>



<div style={{backgroundColor: '#398A7C'}}>

<section className="section_class_ss mt-5" style={{backgroundColor:'#398A7C'}}>
  <img className="Vector_img_obs" src="img/Vector1.png" alt="Design" />
  <div className="container_class_ss container ">
   <div className="row">
    <div className="col-lg-8">
      <h4 className="hearing_h5 pt-5" style={{ textAlign : 'left' }}>With a separate interface for <br /> parents and therapists.</h4>
      <h2 className="sprre pt-3">Teach. Record. Repeat.</h2>
      <div>
        <img className="white_logo_ss" src="img/white_logo.png" alt="Design" width="100" />
      </div>
    </div>
    <div className="col-lg-4" style={{zindex: '999', marginTop: '5%'}}>
      <img src="img/mobile_screen_green.png" alt="Design" width="250" />
    </div>
  </div>
</div>
</section>


</div>


<section className="section_class_ss mt-5" style={{backgroundColor:'#F2F8FF'}}>
  <div className="container_class_center container  ">
    <div className="row">
      <div className="col-lg-8">
        <h4 className="hearing_h4 pt-5" style={{ textAlign : 'left' }}>With personal speech recognition,<br /> visual cues and machine learning.</h4>
        <div>
          <img className="white_logo_ss" src="img/logo_b.png" alt="Design" width="100" />
        </div>
      </div>
      <div className="col-lg-4" style={{zindex: '999'}}>
        <img src="img/recoding.png" alt="Design" width="250" />
      </div>
    </div>
  </div>  
</section>


<section className="section_class_ss mt-5" style={{backgroundColor:'#F2F8FF'}} >
  <div className="container_class_center container">
    <div className="row">
      <div className="col-lg-8">
        <h4 className="hearing_h4 pt-5" style={{ textAlign : 'left' }}>With personal speech recognition,<br /> visual cues and machine learning.</h4>
        <h2 className="sprre_blue pt-3">Speak. Watch. Repeat.</h2>
        <div>
          <img className="white_logo_ss" src="img/logo_b.png" alt="Design" width="100" />
        </div>
      </div>
      <div className="col-lg-4" style={{zindex: '999'}}>
        <img src="img/recoding_t.png" alt="Design" width="250" />
      </div>
    </div>
  </div> 
</section>


<div style={{backgroundColor: '#4A73CD'}}>

<section className="section_class_ss mt-5" style={{backgroundColor:'#4A73CD'}}>
  <div className="container_class_ss container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
        <div className="col-lg-4 bottom-yello-dashed">
        <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
        <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>

        <div className="rectangle_c mt-5"></div>
      </div>
      </div>
    </div>
    
  </div> 
</section>

<section className="section_class_ss mt-5" style={{backgroundColor:'#4A73CD'}}>
  <div className="container_class_ss container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
          <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
            <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>
            <div className="rectangle_c mt-5"></div>
      </div>

    <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2022</h4>
            <p style={{color: '#fff'}}>Entered into AICTE All India YUKTI Innovative Startups Competition and was selected as one of the key social projects to receive seed grant from the Govt. of India.</p>
            <div className="rectangle_c mt-5"></div>
        </div>
      </div>
  
    </div>
  </div> 
</section>

<section className="section_class_ss mt-5" style={{backgroundColor:'#4A73CD'}}>
  <div className="container_class_ss container ">
    <div className="row">
      <h4 className="" style={{color: '#fff', paddingTop: '140px'}}>This is our journey. </h4>
      <div className="row">
        <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2020</h4>
            <p style={{color: '#fff'}}>It started as an M.Des course academic design research project ‘<b>Unmute Speech</b>’ at IDC, IIT Bombay.</p>
            <div className="rectangle_c mt-5"></div>
        </div>

        <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2022</h4>
            <p style={{color: '#fff'}}>Entered into AICTE All India YUKTI Innovative Startups Competition and was selected as one of the key social projects to receive seed grant from the Govt. of India.</p>
            <div className="rectangle_c mt-5"></div>
        </div>

        <div className="col-lg-4 bottom-yello-dashed">
            <h4 className="pt-5" style={{color: '#fff'}}>2024-2025</h4>
            <p style={{color: '#fff'}}>Formally registered
            a startup AblePro Solutions to establish and transition our work into a viable product, ‘Speaklear’.</p>
            <div className="rectangle_c mt-5"></div>
            <FiArrowRight className="corner-icon" />
        </div>
      </div>
    </div>
  </div> 
</section>

</div>

<section className="section_class_ss">
  <div className="container_class_ss container ">
  <div className="row">
    <div className="chat_box mt-20" style={{paddingTop: '150px'}} >
      <img src="img/logo_b.png" alt="logo" width="300" />
    </div>
    <h3 className="pt-3" style={{ textAlign : 'center' }}>needs your voice* to make it happen.</h3>
    <button type="button" className="btn btn-outline-primary mt-5" style={{width:'20%', margin: '0 auto'}}>Download App</button>
    <p style={{textAlign:'center', paddingTop: '150px'}} className="bounce-in">*Non standard speech. Speech that is unclear, atypical or difficult to understand.</p>
  </div>
</div>
</section>
</div>



<section id="registration" className="product-home-register next-section section_class_ss"  > 
<Container className="Containerd">
<p className="para-text-livvic"><span className="high-user">Hello there,</span><br /><br />Speaklear™ application software is being developed as a speech practising and training platform especially for people with<span className="livvic_klear"> hearing and speech impairments.</span> <br /><br />By registering yourself on to this platform, you support us in developing a comprehensive speech database in refining our digital speech training models to yield better speech feedback, thereby helping us provide you better speech rehabilitation opportunities.<br /><br />We have put together a structured unit set for you or your child to record speech patterns. Please complete as much as you can and at your own convenience. 
(Kindly note, we are accepting speech recordings of people or children with atypical, impaired or non-standard speech only). <br /><br />
To learn more: <a href="">www.speaklear.com</a>
<br /><br />
{/* <span className="high-text" >Help us, help you better! </span> */}
</p>
<Row ref={nextSectionRef} className="text-center d-flex align-items-center justify-content-center mt-3">
  <Col xs={12} sm={6} md={4} lg={3} className="d-flex align-items-center">
    <input type="checkbox" id="customCheckbox" className="custom-checkbox me-2" checked={isChecked} onChange={handleCheckboxChange} />
    <label htmlFor="customCheckbox" className="checkbox-label para-text-livvic">I agree to participate.</label>
  </Col>
</Row>

{isChecked && (
  <Row >
    <Col xs={12} sm={12} md={{span:6, offset:3}} lg={{span:6, offset:3}}>
    <form onSubmit={handleSubmit} className="custom-form" >
    <div className="input-container">
      <label>Name *</label>
      <img src={usericon} className="input-icon" />
      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Please enter your full name" title="Enter a valid name" required />
      </div>

      <div className="input-container">
      <label>Email *</label>
      <img src={emailicon} className="input-icon" />
      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Please enter valid email id" title="Enter a valid email address" required />
      
      </div>
      {errors.email && <p className="error">{errors.email}</p>}

      <div className="input-container">
      <label>Mobile *</label>
      <img src={mobileicon} className="input-icon" />
      <input type="text" name="mobile" value={formData.mobile} minLength={10} maxLength={10} placeholder="Please enter valid 10 digit number" title="Enter a valid 10-digit mobile number" onChange={handleChange} required />
      
      </div>
      {errors.mobile && <p className="error">{errors.mobile}</p>}

      <div className="input-container">
      <label>Do you or someone in your household have a speech impairment or a speech disorder? <sup><img src={impo} /></sup></label>
      <p className="para-text-livvic">YES<input type="radio" value="yes" name="inform_us" onChange={handleRadioChange} /> NO<input type="radio" value="no" name="inform_us" onChange={handleRadioChange} /> </p>
      </div>

      <button type="submit" disabled={!isYesChecked} >Submit</button>
    </form>
    </Col>
</Row>
)}
<br />
{/* Custom Alert */}
    {showsuccessAlert && (
        <div className="custom-success-alert">
          <p className="para-text-livvic-center"><span className="high-text">Thank you! </span><br /><span className="high-normal">We acknowledge your registration. We will attend and revert back soon. Please expect an e-mail from us. </span></p>
        </div>
      )}

{showfailureAlert && (
        <div className="custom-failure-alert">
          <p className="para-text-livvic-center"><span className="high-text">Sorry! </span><br /><span className="high-normal">Registration is only for people with hearing and/or speech impairments at this time.<br />Kindly write an email to learn more at: <a href="mailto:support@ableproindia.com">support@ableproindia.com</a></span></p>
          <p align="center"><button className="ok_button" onClick={handlehidefailuremsg}>OK</button></p>
        </div>
      )}
</Container>
</section>



<Footer></Footer>
  </>
  )
}

export default Productdetailsobs
